<div class="gp-page">
  <!-- Page header -->
  <div class="gp-page-header">
    <h1 class="gp-page-title">Pending Approvals</h1>
  </div>
  <div class="col-12 p-1">
    <div class="row align-items-center">
      <div class="col-md-4 rounded-4">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item flex-fill" role="presentation">
            <button class="nav-link w-100 trips_tabs" id="pending-tab" [class.active]="activeTab === 'pending'"
              (click)="switchTab('pending')" type="button" role="tab">
              Flights <span class="tab-count" *ngIf="trips.length">{{ trips.length }}</span>
            </button>
          </li>
          <li class="nav-item flex-fill" role="presentation">
            <button class="nav-link w-100 trips_tabs" id="car-hire-tab" [class.active]="activeTab === 'car-hire'"
              (click)="switchTab('car-hire')" type="button" role="tab">
              Car Hire <span class="tab-count" *ngIf="carRentals.length">{{ carRentals.length }}</span>
            </button>
          </li>
          <li class="nav-item flex-fill" role="presentation">
            <button class="nav-link w-100 trips_tabs" id="hotels-tab" [class.active]="activeTab === 'hotels'"
              (click)="switchTab('hotels')" type="button" role="tab">
              Hotels <span class="tab-count" *ngIf="hotels.length">{{ hotels.length }}</span>
            </button>
          </li>
        </ul>
      </div>

      <div class="col d-flex justify-content-end">
        <div class="trips-filter-wrapper">
          <button class="trips-filter-btn" (click)="$event.stopPropagation(); filterOpen = !filterOpen">
            <i class="bi bi-sliders"></i>
            Filter
            <span class="filter-active-dot" *ngIf="hasActiveFilters"></span>
          </button>

          <div class="trips-filter-panel" *ngIf="filterOpen">
            <div class="filter-section">
              <label class="filter-label">Status</label>
              <div class="filter-chips">
                <button class="filter-chip" [class.active]="filters.status === ''"
                  (click)="filters.status = ''">All</button>
                <button class="filter-chip" [class.active]="filters.status === 'APPROVED'"
                  (click)="filters.status = 'APPROVED'">Approved</button>
                <button class="filter-chip" [class.active]="filters.status === 'PENDING'"
                  (click)="filters.status = 'PENDING'">Pending</button>
                <button class="filter-chip" [class.active]="filters.status === 'REJECTED'"
                  (click)="filters.status = 'REJECTED'">Rejected</button>
              </div>
            </div>

            <div class="filter-section">
              <label class="filter-label">Amount</label>
              <div class="filter-slider-block">
                <div class="filter-slider-row">
                  <span class="filter-slider-label">Min</span>
                  <span class="filter-slider-value">{{ (filters.minAmount ?? 0) | corpCurrency }}</span>
                </div>
                <input class="filter-range-slider" type="range" [min]="0" [max]="maxCurrentTabAmount"
                  [value]="filters.minAmount ?? 0" (input)="filters.minAmount = +$any($event.target).value"
                  (change)="filters.minAmount = +$any($event.target).value" />
                <div class="filter-range-bounds">
                  <span>0</span><span>{{ maxCurrentTabAmount | number }}</span>
                </div>
              </div>
              <div class="filter-slider-block">
                <div class="filter-slider-row">
                  <span class="filter-slider-label">Max</span>
                  <span class="filter-slider-value">{{ (filters.maxAmount ?? maxCurrentTabAmount) | corpCurrency }}</span>
                </div>
                <input class="filter-range-slider" type="range" [min]="0" [max]="maxCurrentTabAmount"
                  [value]="filters.maxAmount ?? maxCurrentTabAmount"
                  (input)="filters.maxAmount = +$any($event.target).value"
                  (change)="filters.maxAmount = +$any($event.target).value" />
                <div class="filter-range-bounds">
                  <span>0</span><span>{{ maxCurrentTabAmount | number }}</span>
                </div>
              </div>
            </div>

            <div class="filter-section">
              <label class="filter-label">Travel Date (from)</label>
              <input class="filter-input w-100" type="date" [(ngModel)]="filters.travelDate" />
            </div>

            <div class="filter-actions">
              <button class="filter-reset-btn" (click)="resetFilters()">Reset</button>
              <button class="filter-apply-btn" (click)="applyFilters()">Apply</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-content mt-4" id="myTabContent">
      <span *ngIf="loader" class="loading-text">Loading ...</span>
      <div class="tab-pane fade" [class.active]="activeTab === 'pending'" [class.show]="activeTab === 'pending'">
        <div *ngIf="isTripsloaded">
          <div class="approval-grid">
            <ng-container *ngFor="let trip of filteredFlights">
              <div *ngIf="trip.booking_request.channels === 'flights'" class="premium-card"
                [class.out-of-policy]="trip.booking_request.policy_violations.length">

                <div class="policy-indicator-pill" *ngIf="trip.booking_request.policy_violations.length">
                  OUT OF POLICY
                </div>

                <div class="card-top">
                  <div class="status-badge" [ngClass]="{ 
                      'status-pending': trip.status == 'PENDING',
                      'status-failed': trip.status == 'REJECTED',
                      'status-approved': trip.status == 'APPROVED' 
                    }">
                    {{ trip.status }}
                  </div>
                  <!-- <div class="view-indicator" (click)="handleTripModal(content, trip)">
                      <i class="bi bi-eye"></i>
                    </div> -->
                </div>

                <div class="trip-owner">
                  {{ trip.booking_request.booking_details.passengers[0].given_name }}'s trip
                </div>

                <div class="route-container">
                  <div class="location-item">
                    <span class="airport-code">{{
                      trip.booking_request.booking_details?.outbound.trip_details.slices[0].origin.iata_code }}</span>
                    <span class="airport-name">{{
                      trip.booking_request.booking_details?.outbound.trip_details.slices[0].origin.name }}</span>
                  </div>

                  <div class="route-arrow">
                    <i class="bi bi-arrow-right"></i>
                  </div>

                  <div class="location-item text-end">
                    <span class="airport-code">{{
                      trip.booking_request.booking_details?.outbound.trip_details.slices[0].destination.iata_code
                      }}</span>
                    <span class="airport-name">{{
                      trip.booking_request.booking_details?.outbound.trip_details.slices[0].destination.name
                      }}</span>
                  </div>
                </div>

                <div class="card-details-row">
                  <div class="price-display">
                    <span class="price-label">Total Amount</span>
                    <span class="price-value">{{
                      trip.booking_request.booking_details.outbound.trip_details.total_amount | corpCurrency }}</span>
                  </div>

                  <div class="trip-info-summary">
                    <span class="info-date">{{
                      formatDateToYYYYMM(trip.booking_request.booking_details?.outbound.trip_details.slices[0].departing_day)
                      }}</span>
                    <span class="info-meta">Stage {{trip.approval_stage_sequence}}/{{ trip.approval_total_stages
                      }}</span>
                  </div>
                </div>

                <div class="card-actions">
                  <!-- <button type="button" class="btn-premium btn-details" (click)="handleTripModal(content, trip)">
                      <i class="bi bi-info-circle"></i> Details
                    </button> -->
                  <button type="button" class="btn-premium btn-action" (click)="handleTripModal(content, trip)"
                    [disabled]="trip.isLoading">
                    <span *ngIf="!trip.isLoading">Approve / Reject</span>
                    <mat-spinner diameter="18" *ngIf="trip.isLoading"></mat-spinner>
                  </button>
                </div>

                <!-- Hover Policy Overlay -->
                <div class="policy-overlay" *ngIf="trip.booking_request.policy_violations.length">
                  <div class="overlay-inner p-4">
                    <h5 class="mb-3">Policy Violation</h5>
                    <div class="overlay-title mb-2 small">
                      {{ trip.booking_request.policy_violations[0]?.policy_name }}
                    </div>
                    <ul class="overlay-reasons list-unstyled text-start mb-4">
                      <li *ngFor="let reason of trip.booking_request.policy_violations[0]?.violations"
                        class="small mb-2">
                        <i class="bi bi-exclamation-triangle-fill me-2 text-warning"></i>{{ reason }}
                      </li>
                    </ul>
                    <button type="button" class="btn btn-action btn-md w-100 fw-bold"
                      (click)="handleTripModal(content, trip)" [disabled]="trip.isLoading">
                      View Details & Act
                    </button>
                  </div>
                </div>
              </div>

              <div *ngIf="trip.booking_request.channels === 'buses'" class="premium-card"
                [class.out-of-policy]="trip.booking_request.policy_violations.length">

                <div class="policy-indicator-pill" *ngIf="trip.booking_request.policy_violations.length">
                  OUT OF POLICY
                </div>

                <div class="card-top">
                  <div class="status-badge" [ngClass]="{ 
                      'status-pending': trip.status == 'PENDING',
                      'status-failed': trip.status == 'REJECTED',
                      'status-approved': trip.status == 'APPROVED' 
                    }">
                    {{ trip.status }}
                  </div>
                  <!-- <div class="view-indicator" (click)="handleTripModal(content, trip)">
                      <i class="bi bi-eye"></i>
                    </div> -->
                </div>

                <div class="trip-owner">
                  {{ trip.booking_request.booking_details?.passengers[0]?.full_name }}'s Bus Trip
                </div>

                <div class="route-container">
                  <div class="location-item">
                    <span class="airport-code">{{
                      trip.booking_request.booking_details.tripDetails.slices[0].origin.name }}</span>
                    <span class="airport-name">Departure</span>
                  </div>

                  <div class="route-arrow">
                    <i class="bi bi-arrow-right"></i>
                  </div>

                  <div class="location-item text-end">
                    <span class="airport-code">{{
                      trip.booking_request.booking_details.tripDetails.slices[0].destination.name }}</span>
                    <span class="airport-name">Destination</span>
                  </div>
                </div>

                <div class="card-details-row">
                  <div class="price-display">
                    <span class="price-label">Total Amount</span>
                    <span class="price-value">{{ trip.booking_request.booking_details.payments.amount | corpCurrency
                      }}/-</span>
                  </div>

                  <div class="trip-info-summary">
                    <span class="info-date">{{
                      formatDateToYYYYMM(trip.booking_request.booking_details.tripDetails.slices[0].departing_day)
                      }}</span>
                    <span class="info-meta">Seat: {{ trip.booking_request.booking_details.passengers[0].seat.id
                      }}</span>
                  </div>
                </div>

                <div class="card-actions">
                  <!-- <button type="button" class="btn-premium btn-details" (click)="handleTripModal(content, trip)">
                      <i class="bi bi-info-circle"></i> Details
                    </button> -->
                  <button type="button" class="btn-premium btn-action" (click)="handleTripModal(content, trip)"
                    [disabled]="trip.isLoading">
                    <span *ngIf="!trip.isLoading">Approve / Reject</span>
                    <mat-spinner diameter="18" *ngIf="trip.isLoading"></mat-spinner>
                  </button>
                </div>

                <!-- Hover Policy Overlay -->
                <div class="policy-overlay" *ngIf="trip.booking_request.policy_violations.length">
                  <div class="overlay-inner p-4">
                    <h5 class="mb-3">Policy Violation</h5>
                    <div class="overlay-title mb-2 small">
                      {{ trip.booking_request.policy_violations[0]?.policy_name }}
                    </div>
                    <ul class="overlay-reasons list-unstyled text-start mb-4">
                      <li *ngFor="let reason of trip.booking_request.policy_violations[0]?.violations"
                        class="small mb-2">
                        <i class="bi bi-exclamation-triangle-fill me-2 text-warning"></i>{{ reason }}
                      </li>
                    </ul>
                    <button type="button" class="btn btn-action btn-md w-100 fw-bold"
                      (click)="handleTripModal(content, trip)" [disabled]="trip.isLoading">
                      View Details & Act
                    </button>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <ng-container *ngIf="trips.length === 0 && !loader">
          <div class="no-approval-stages">
            <p>No Pending Approvals</p>
          </div>
        </ng-container>
      </div>

      <!-- Consolidated Modal Templates -->
      <ng-template #content let-modal>
        <div class="modal-header">
          <h1 class="modal-title fs-5 text-center" id="tripReasonModalLabel">
            Trip Details
          </h1>
          <button type="button" class="btn-close" (click)="hideModal(modal)">
            <i class="bi bi-x"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="modal-row d-flex align-items-center justify-content-between">
            <div class="modal-label">Name ~ </div>
            <div style="font-weight: 600;">
              {{
              selectedTrip?.booking_request?.booking_details.passengers[0].given_name
              +' '+
              selectedTrip?.booking_request?.booking_details.passengers[0].family_name
              }}
            </div>
          </div>
          <div class="modal-row d-flex align-items-center justify-content-between">
            <div class="modal-label">Travel Reason ~ </div>
            <div style="font-weight: 600;">{{ selectedTrip?.booking_request?.booking_details.reason }}</div>
          </div>
          <div class="modal-row d-flex align-items-center justify-content-between">
            <div class="modal-label">Price ~ </div>
            <ng-container *ngIf="
                  selectedTrip?.booking_request?.booking_details.outbound.payments.amount  &&
                  selectedTrip?.booking_request?.booking_details?.inbound?.payments?.amount; 
                  else notReturnTripPrice
                ">
              <div class="d-flex flex-column">
                <div style="font-weight: 600;">
                  {{ selectedTrip?.booking_request?.booking_details.outbound.payments.amount | corpCurrency }} (Outward)
                </div>
                <div style="font-weight: 600;">
                  {{selectedTrip?.booking_request?.booking_details.inbound.payments.amount | corpCurrency}} (Return)
                </div>
              </div>
            </ng-container>
            <ng-template #notReturnTripPrice>
              <div style="font-weight: 600;">
                {{selectedTrip?.booking_request?.booking_details.outbound.payments.amount | corpCurrency}} (Outward)
              </div>
            </ng-template>
          </div>
          <div class="modal-row d-flex align-items-center justify-content-between">
            <div class="modal-label">Trip type ~</div>
            <ng-container
              *ngIf="
                  selectedTrip?.booking_request?.booking_details.outbound.trip_details.slices.length
                  && selectedTrip?.booking_request?.booking_details?.inbound?.trip_details.slices.length; else notReturnTripType">
              <div style="font-weight: 600;"> Return </div>
            </ng-container>
            <ng-template #notReturnTripType>
              <div style="font-weight: 600;"> Single</div>
            </ng-template>
          </div>
          <div class="modal-row d-flex align-items-center justify-content-between">
            <div class="modal-label">Approval Stage</div>
            <div style="font-weight: 600;">Stage {{selectedTrip.approval_stage_sequence}}/{{
              selectedTrip.approval_total_stages }}</div>
          </div>

          <!-- Flight/Bus Slices -->
          <ng-container
            *ngIf="selectedTrip?.booking_request?.channels === 'flights' || selectedTrip?.booking_request?.channels === 'buses'">
            <ng-container
              *ngIf="selectedTrip?.booking_request?.booking_details.outbound.trip_details.slices.length
                && selectedTrip?.booking_request?.booking_details?.inbound?.trip_details.slices.length; else notReturnSlices">
              <ng-container *ngFor="
                    let t of selectedTrip?.booking_request?.booking_details.outbound.trip_details.slices; index as tripIdx
                  ">
                <div class="d-flex flex-column">
                  <span style="background-color: #a9a8a7ad; padding: 5px;">Outward</span>
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="">Airline ~ </div>
                    <div class="d-flex flex-column align-items-center justify-content-between">
                      <div style="font-weight: 600;">
                        {{ t?.segments[0]?.operating_carrier?.name }}
                      </div>
                    </div>
                  </div>
                  <div class="my-1 d-flex align-items-center justify-content-between">
                    <div class="">Flight No. </div>
                    <div style="font-weight: 600;">{{
                      t?.segments[1]?.operating_carrier?.flight_number
                      ? t?.segments[0]?.operating_carrier?.flight_number
                      : t?.segments[0]?.marketing_carrier?.flight_number}} </div>
                  </div>
                  <div class="my-1 d-flex align-items-center justify-content-between">
                    <div class="">Departure ~ </div>
                    <div class="d-flex flex-column align-items-center justify-content-between">
                      <div style="font-weight: 600;">
                        {{ t?.segments[0]?.origin.city_name }}
                      </div>
                    </div>
                  </div>
                  <div class="my-1 d-flex align-items-center justify-content-between">
                    <div class="">Destination ~ </div>
                    <div class="d-flex flex-column align-items-center justify-content-between">
                      <div style="font-weight: 600;">
                        {{ t?.segments[t?.segments.length-1]?.destination.city_name }}
                      </div>
                    </div>
                  </div>
                  <div class="my-1 d-flex align-items-center justify-content-between">
                    <div class=""> Departure Time ~ </div>
                    <div style="font-weight: 600;">
                      {{ t?.segments[0]?.departing_at | dateFilter : "YYYY-MM-DDTHH:mm:ss" : "TIME" }},
                      {{ t?.segments[0]?.departing_at | dateFilter : "YYYY-MM-DDTHH:mm:ss" : "DD MM YYYY" }}
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngFor="
                  let t of selectedTrip?.booking_request?.booking_details?.inbound?.trip_details.slices; index as tripIdx
                ">
                <div class="my-1 d-flex flex-column">
                  <span style="background-color: #a9a8a7ad; padding: 5px;">Return</span>
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="">Airline ~ </div>
                    <div class="d-flex flex-column align-items-center justify-content-between">
                      <div style="font-weight: 600;">
                        {{ t?.segments[0]?.operating_carrier?.name }}
                      </div>
                    </div>
                  </div>
                  <div class="my-1 d-flex align-items-center justify-content-between">
                    <div class="">Flight No. </div>
                    <div style="font-weight: 600;">{{
                      t?.segments[0]?.operating_carrier?.flight_number
                      ? t?.segments[0]?.operating_carrier?.flight_number
                      : t?.segments[0]?.marketing_carrier?.flight_number}} </div>
                  </div>
                  <div class="my-1 d-flex align-items-center justify-content-between">
                    <div class="">Departure ~ </div>
                    <div class="d-flex flex-column align-items-center justify-content-between">
                      <div style="font-weight: 600;">
                        {{ t?.segments[0]?.origin.city_name }}
                      </div>
                    </div>
                  </div>
                  <div class="my-1 d-flex align-items-center justify-content-between">
                    <div class="">Destination ~ </div>
                    <div class="d-flex flex-column align-items-center justify-content-between">
                      <div style="font-weight: 600;">
                        {{ t?.segments[t?.segments.length-1]?.destination.city_name }}
                      </div>
                    </div>
                  </div>
                  <div class="my-1 d-flex align-items-center justify-content-between">
                    <div class=""> Departure Time ~ </div>
                    <div style="font-weight: 600;">
                      {{ t?.segments[0]?.departing_at | dateFilter : "YYYY-MM-DDTHH:mm:ss" : "TIME" }},
                      {{ t?.segments[0]?.departing_at | dateFilter : "YYYY-MM-DDTHH:mm:ss" : "DD MM YYYY" }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #notReturnSlices>
              <ng-container *ngFor="
                    let t of selectedTrip?.booking_request?.booking_details?.inbound?.trip_details.slices;
                  ">
                <div class="d-flex flex-column">
                  <span style="background-color: #a9a8a7ad; padding: 5px;">Outbound</span>
                  <div class="modal-row d-flex align-items-center justify-content-between">
                    <div class="modal-label">Airline ~ </div>
                    <div class="d-flex flex-column align-items-center justify-content-between">
                      <div style="font-weight: 600;">
                        {{ t?.segments[0]?.operating_carrier?.name }}
                      </div>
                    </div>
                  </div>
                  <div class="modal-row d-flex align-items-center justify-content-between">
                    <div class="modal-label">Flight No. </div>
                    <div style="font-weight: 600;">{{ t?.segments[0]?.operating_carrier?.flight_number }} </div>
                  </div>
                  <div class="modal-row d-flex align-items-center justify-content-between">
                    <div class="modal-label"> Departure Time ~ </div>
                    <div style="font-weight: 600;">
                      {{ t?.segments[0]?.departing_at | dateFilter : "YYYY-MM-DDTHH:mm:ss" : "TIME" }},
                      {{ t?.segments[0]?.departing_at | dateFilter : "YYYY-MM-DDTHH:mm:ss" : "DD MM YYYY" }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-template>
          </ng-container>

          <!-- Car Hire Specifics -->
          <ng-container
            *ngIf="selectedTrip?.booking_request?.channels === 'car-hire' || selectedTrip?.booking_request?.channels === 'car-rentals'">
            <div class="modal-row d-flex align-items-center justify-content-between my-2">
              <div class="modal-label">Pick-up</div>
              <div style="font-weight: 600;">{{
                selectedTrip.booking_request.booking_details.outbound.trip_details.pick_up }}</div>
            </div>
            <div class="modal-row d-flex align-items-center justify-content-between my-2">
              <div class="modal-label">Drop-off</div>
              <div style="font-weight: 600;">{{
                selectedTrip.booking_request.booking_details.outbound.trip_details.drop_off }}</div>
            </div>
            <div class="modal-row d-flex align-items-center justify-content-between my-2">
              <div class="modal-label">Car Type</div>
              <div style="font-weight: 600;">{{
                selectedTrip.booking_request.booking_details.outbound.trip_details.car_type?.model }}</div>
            </div>
            <div class="modal-row d-flex align-items-center justify-content-between my-2">
              <div class="modal-label">Rental Type</div>
              <div style="font-weight: 600;">{{
                selectedTrip.booking_request.booking_details.outbound.trip_details.rental_type }}</div>
            </div>
            <div class="modal-row d-flex align-items-center justify-content-between my-2">
              <div class="modal-label">Start Date</div>
              <div style="font-weight: 600;">{{
                formatDateToYYYYMM(selectedTrip.booking_request.booking_details.outbound.trip_details.hire_start_date)
                }}</div>
            </div>
          </ng-container>
        </div>
        <div class="modal-footer">

          <div class="mb-2 d-flex flex-row flex-row-reverse w-100 px-3" [hidden]="!auth.isApprover()">
            <button type="button" class="btn btn-outline-danger" (click)="openRejectModal(selectedTrip)"
              style="margin-left: 10px" [disabled]="selectedTrip.isRejectLoading">
              <ng-container *ngIf="selectedTrip.isRejectLoading; else notrejectLoading">
                <mat-spinner diameter="20"></mat-spinner>
              </ng-container>
              <ng-template #notrejectLoading>
                Reject
              </ng-template>
            </button>

            <ng-container *ngIf="selectedTrip.booking_request.policy_violations.length > 0; else notOutOfPolicy">
              <button type="button" class="btn btn-action" (click)="openOutOfPolicyModal(selectedTrip)"
                [disabled]="selectedTrip.isLoading">
                <ng-container *ngIf="selectedTrip.isLoading; else notLoading">
                  <mat-spinner diameter="20"></mat-spinner>
                </ng-container>
                <ng-template #notLoading>
                  <span *ngIf="selectedTrip.approval_stage_sequence === selectedTrip.approval_total_stages">Approve
                    &
                    Pay</span>
                  <span
                    *ngIf="selectedTrip.approval_stage_sequence !== selectedTrip.approval_total_stages">Approve</span>
                </ng-template>
              </button>
            </ng-container>

            <ng-template #notOutOfPolicy>
              <button type="button" class="btn btn-action" (click)="approve(modal, selectedTrip)"
                [disabled]="selectedTrip.isLoading">
                <ng-container *ngIf="selectedTrip.isLoading; else notLoading">
                  <mat-spinner diameter="20"></mat-spinner>
                </ng-container>
                <ng-template #notLoading>
                  <span *ngIf="selectedTrip.approval_stage_sequence === selectedTrip.approval_total_stages">Approve
                    &
                    Pay</span>
                  <span
                    *ngIf="selectedTrip.approval_stage_sequence !== selectedTrip.approval_total_stages">Approve</span>
                </ng-template>
              </button>
            </ng-template>
          </div>

          <!-- Rejection Reason Field -->
          <div class="p-3 bg-white border rounded shadow-sm w-100 mx-3 mb-3"
            *ngIf="selectedTrip.booking_request.id === isRejectTripModal">
            <p class="small mb-2">Enter a reason for rejecting this trip</p>
            <input type="text" [(ngModel)]="rejectData.reason" [ngModelOptions]="{ standalone: true }"
              class="form-control mb-2" placeholder="Enter Reason" />
            <div *ngIf="errorStageMessage" class="text-center text-danger small mb-2">
              <span>{{errorStageMessage}}</span>
            </div>
            <div class="d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-sm text-secondary" (click)="closeRejectModal()">
                Cancel
              </button>
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="reject(modal)"
                [disabled]="selectedTrip.isRejectLoading">
                <ng-container *ngIf="selectedTrip.isRejectLoading; else notrejectLoading">
                  <mat-spinner diameter="20"></mat-spinner>
                </ng-container>
                <ng-template #notrejectLoading>
                  Confirm Reject
                </ng-template>
              </button>
            </div>
          </div>

          <!-- Out of Policy Reason Field -->
          <div class="p-3 bg-white border rounded shadow-sm w-100 mx-3 mb-3"
            *ngIf="selectedTrip.booking_request.id === isApproveOutOfPolicyModal">
            <p class="small mb-2">Enter a reason for approving out of policy trip</p>
            <input type="text" [(ngModel)]="approveOutOfPolicyData.reason" [ngModelOptions]="{ standalone: true }"
              class="form-control mb-2" placeholder="Enter Reason" />
            <div *ngIf="errorStageMessage" class="text-center text-danger small mb-2">
              <span>{{errorStageMessage}}</span>
            </div>
            <div class="d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-sm text-secondary" (click)="closeRejectModal()">
                Cancel
              </button>
              <button type="button" class="btn btn-sm btn-action" (click)="approveOutOfPolicyHotel(modal, selectedTrip)"
                [disabled]="selectedTrip?.isLoading">
                <ng-container *ngIf="selectedTrip?.isLoading; else notLoading">
                  <mat-spinner diameter="20"></mat-spinner>
                </ng-container>
                <ng-template #notLoading>
                  Confirm Approve
                </ng-template>
              </button>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #hotelContent let-modal>
        <div class="modal-header">
          <h1 class="modal-title fs-5 text-center" id="tripReasonModalLabel">
            Hotel Reservation Details
          </h1>
          <button type="button" class="btn-close" (click)="hideModal(modal)">
            <i class="bi bi-x"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="modal-row d-flex align-items-center justify-content-between mb-3">
            <div class="modal-label">Name ~ </div>
            <div style="font-weight: 600;">
              {{ selectedTrip?.creator }}
            </div>
          </div>
          <div class="modal-row d-flex align-items-center justify-content-between mb-3">
            <div class="modal-label">Travel Reason ~ </div>
            <div style="font-weight: 600;">{{ selectedTrip?.booking_request?.booking_details.reason }}</div>
          </div>
          <div class="modal-row d-flex align-items-center justify-content-between mb-3">
            <div class="modal-label">Price ~ </div>
            <div class="d-flex flex-column">
              <div style="font-weight: 600;">
                {{ selectedTrip?.booking_request?.booking_details.currency + ' ' }} {{
                selectedTrip?.booking_request?.booking_details.total_price }}
              </div>
            </div>
          </div>
          <div class="modal-row d-flex align-items-center justify-content-between mb-3">
            <div class="modal-label">Approval Stage</div>
            <div style="font-weight: 600;">Stage {{selectedTrip.approval_stage_sequence}}/{{
              selectedTrip.approval_total_stages }}</div>
          </div>
        </div>
        <div class="modal-footer">
          <div style="position: relative;" class="mb-2 d-flex flex-row flex-row-reverse w-100 px-3"
            [hidden]="!auth.isApprover()">
            <button type="button" class="btn btn-outline-danger" (click)="openRejectModal(selectedTrip)"
              style="margin-left: 10px" [disabled]="selectedTrip?.isLoading">
              <ng-container *ngIf="selectedTrip?.isRejectLoading; else notrejectLoading">
                <mat-spinner diameter="20"></mat-spinner>
              </ng-container>
              <ng-template #notrejectLoading>
                Reject
              </ng-template>
            </button>

            <ng-container *ngIf="selectedTrip?.booking_request?.policy_violations?.length > 0; else notOutOfPolicy">
              <button type="button" class="btn btn-action" (click)="openOutOfPolicyModal(selectedTrip)"
                [disabled]="selectedTrip?.isLoading">
                <ng-container *ngIf="selectedTrip?.isLoading; else notLoading">
                  <mat-spinner diameter="20"></mat-spinner>
                </ng-container>
                <ng-template #notLoading>
                  <span *ngIf="selectedTrip.approval_stage_sequence === selectedTrip.approval_total_stages">Approve &
                    Pay</span>
                  <span
                    *ngIf="selectedTrip.approval_stage_sequence !== selectedTrip.approval_total_stages">Approve</span>
                </ng-template>
              </button>
            </ng-container>

            <ng-template #notOutOfPolicy>
              <button type="button" class="btn btn-action" (click)="approveHotel(modal, selectedTrip)"
                [disabled]="selectedTrip?.isLoading">
                <ng-container *ngIf="selectedTrip?.isLoading; else notLoading">
                  <mat-spinner diameter="20"></mat-spinner>
                </ng-container>
                <ng-template #notLoading>
                  <span *ngIf="selectedTrip.approval_stage_sequence === selectedTrip.approval_total_stages">Approve &
                    Pay</span>
                  <span
                    *ngIf="selectedTrip.approval_stage_sequence !== selectedTrip.approval_total_stages">Approve</span>
                </ng-template>
              </button>
            </ng-template>
          </div>

          <!-- Rejection Reason Overlay -->
          <div class="p-3 bg-white border rounded shadow-sm w-100 mx-3 mb-3"
            *ngIf="selectedTrip?.booking_request?.id === isRejectTripModal">
            <p class="small mb-2">Enter a reason for rejecting this trip</p>
            <input type="text" [(ngModel)]="rejectData.reason" [ngModelOptions]="{ standalone: true }"
              class="form-control mb-2" placeholder="Enter Reason" />
            <div *ngIf="errorStageMessage" class="text-center text-danger small mb-2">
              <span>{{errorStageMessage}}</span>
            </div>
            <div class="d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-sm text-secondary" (click)="closeRejectModal()">
                Cancel
              </button>
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="reject(modal)"
                [disabled]="selectedTrip.isRejectLoading">
                <ng-container *ngIf="selectedTrip.isRejectLoading; else notrejectLoading">
                  <mat-spinner diameter="20"></mat-spinner>
                </ng-container>
                <ng-template #notrejectLoading>
                  Confirm Reject
                </ng-template>
              </button>
            </div>
          </div>

          <!-- Out of Policy Reason Overlay -->
          <div class="p-3 bg-white border rounded shadow-sm w-100 mx-3 mb-3"
            *ngIf="selectedTrip?.booking_request?.id === isApproveOutOfPolicyModal">
            <p class="small mb-2">Enter a reason for approving out of policy trip</p>
            <input type="text" [(ngModel)]="approveOutOfPolicyData.reason" [ngModelOptions]="{ standalone: true }"
              class="form-control mb-2" placeholder="Enter Reason" />
            <div *ngIf="errorStageMessage" class="text-center text-danger small mb-2">
              <span>{{errorStageMessage}}</span>
            </div>
            <div class="d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-sm text-secondary" (click)="closeRejectModal()">
                Cancel
              </button>
              <button type="button" class="btn btn-sm btn-action" (click)="approveOutOfPolicyHotel(modal, selectedTrip)"
                [disabled]="selectedTrip?.isLoading">
                <ng-container *ngIf="selectedTrip?.isLoading; else notLoading">
                  <mat-spinner diameter="20"></mat-spinner>
                </ng-container>
                <ng-template #notLoading>
                  Confirm Approve
                </ng-template>
              </button>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #hotelRateModal let-modal>
        <div class="modal-header">
          <h4 class="modal-title">Hotel Rate Details</h4>
          <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <span *ngIf="priceChangeDetected">
            This reservation has a new price
            <div style="font-weight: 600;">{{newHotelPrice}}</div>
          </span>
          <br />
          <div [innerHTML]="notes"></div>
        </div>
        <div class="modal-footer">
          <div class="d-flex justify-content-end w-100 gap-3 px-3" [hidden]="!auth.isApprover()">
            <button type="button" class="btn btn-action" (click)="completeApproval(modal, selectedTrip)"
              [disabled]="selectedTrip?.isLoading">
              <span *ngIf="selectedTrip?.approval_stage_sequence === selectedTrip?.approval_total_stages">Complete
                Approval</span>
              <span *ngIf="selectedTrip?.approval_stage_sequence !== selectedTrip?.approval_total_stages">Approve</span>
            </button>
            <button type="button" class="btn btn-outline-danger" (click)="openRejectModal(selectedTrip)"
              [disabled]="selectedTrip?.isLoading">
              Reject
            </button>
          </div>
        </div>
      </ng-template>

      <div class="tab-pane fade" [class.active]="activeTab === 'car-hire'" [class.show]="activeTab === 'car-hire'">
        <div *ngIf="isTripsloaded">
          <div class="approval-grid">
            <div *ngFor="let trip of filteredCarRentals" class="premium-card"
              [class.out-of-policy]="trip.booking_request.policy_violations.length">

              <div class="policy-indicator-pill" *ngIf="trip.booking_request.policy_violations.length">
                OUT OF POLICY
              </div>

              <div class="card-top">
                <div class="status-badge" [ngClass]="{ 
                    'status-pending': trip.status == 'PENDING',
                    'status-failed': trip.status == 'REJECTED',
                    'status-approved': trip.status == 'APPROVED' 
                  }">
                  {{ trip.status }}
                </div>
                <!-- <div class="view-indicator" (click)="handleCarModal(content, trip)">
                    <i class="bi bi-eye"></i>
                  </div> -->
              </div>

              <div class="trip-owner">
                {{ trip.booking_request.booking_details.outbound.trip_details.requester_name }}'s Car Hire
              </div>

              <div class="route-container">
                <div class="location-item">
                  <span class="airport-code">{{ trip.booking_request.booking_details.outbound.trip_details.pick_up
                    }}</span>
                  <span class="airport-name">Pick-up Location</span>
                </div>

                <div class="route-arrow">
                  <i class="bi bi-arrow-right"></i>
                </div>

                <div class="location-item text-end">
                  <span class="airport-code">{{ trip.booking_request.booking_details.outbound.trip_details.drop_off
                    }}</span>
                  <span class="airport-name">Drop-off Location</span>
                </div>
              </div>

              <div class="card-details-row">
                <div class="price-display">
                  <span class="price-label">Estimated Cost</span>
                  <span class="price-value"
                    *ngIf="trip.booking_request.booking_details.outbound.trip_details.estimated_cost">
                    {{ trip.booking_request.booking_details.outbound.trip_details.estimated_cost | corpCurrency }}
                  </span>
                </div>

                <div class="trip-info-summary">
                  <span class="info-date">
                    {{ formatDateToYYYYMM(trip.booking_request.booking_details.outbound.trip_details.hire_start_date)
                    }}
                  </span>
                  <span class="info-meta">
                    {{ trip.booking_request.booking_details.outbound.trip_details.rental_type }} |
                    {{ trip.booking_request.booking_details.outbound.trip_details.car_type?.model }}
                  </span>
                </div>
              </div>

              <div class="card-actions">
                <!-- <button type="button" class="btn-premium btn-details" (click)="handleCarModal(content, trip)">
                    <i class="bi bi-info-circle"></i> Details
                  </button> -->
                <button type="button" class="btn-premium btn-action" (click)="handleCarModal(content, trip)"
                  [disabled]="trip.isLoading">
                  <span *ngIf="!trip.isLoading">Approve / Reject</span>
                  <mat-spinner diameter="18" *ngIf="trip.isLoading"></mat-spinner>
                </button>
              </div>

              <!-- Hover Policy Overlay -->
              <div class="policy-overlay" *ngIf="trip.booking_request.policy_violations.length">
                <div class="overlay-inner p-4">
                  <h5 class="mb-3">Policy Violation</h5>
                  <div class="overlay-title mb-2 small">
                    {{ trip.booking_request.policy_violations[0]?.policy_name }}
                  </div>
                  <ul class="overlay-reasons list-unstyled text-start mb-4">
                    <li *ngFor="let reason of trip.booking_request.policy_violations[0]?.violations" class="small mb-2">
                      <i class="bi bi-exclamation-triangle-fill me-2 text-warning"></i>{{ reason }}
                    </li>
                  </ul>
                  <button type="button" class="btn btn-action btn-md w-100 fw-bold"
                    (click)="handleCarModal(content, trip)" [disabled]="trip.isLoading">
                    View Details & Act
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="carRentals.length === 0 && !loader">
          <div class="no-approval-stages">
            <p>No Pending Car Hire Approvals</p>
          </div>
        </ng-container>
      </div>
      <div class="tab-pane fade" [class.active]="activeTab === 'hotels'" [class.show]="activeTab === 'hotels'">
        <div *ngIf="isTripsloaded">
          <div class="approval-grid">
            <div *ngFor="let trip of filteredHotels" class="premium-card"
              [class.out-of-policy]="trip.booking_request.policy_violations.length">

              <div class="policy-indicator-pill" *ngIf="trip.booking_request.policy_violations.length">
                OUT OF POLICY
              </div>

              <div class="card-top">
                <div class="status-badge" [ngClass]="{ 
                    'status-pending': trip.status == 'PENDING',
                    'status-failed': trip.status == 'REJECTED',
                    'status-approved': trip.status == 'APPROVED' 
                  }">
                  {{ trip.status }}
                </div>
                <!-- <div class="view-indicator" (click)="handleTripModal(content, trip)">
                    <i class="bi bi-eye"></i>
                  </div> -->
              </div>

              <div class="trip-owner">
                {{ trip.user }}'s Hotel Stay
              </div>

              <div class="route-container" style="margin-bottom: 1rem;">
                <div class="location-item w-100">
                  <span class="airport-code" style="font-size: 1.25rem;">{{
                    trip.booking_request.booking_details.hotel_name }}</span>
                  <span class="airport-name"><i class="bi bi-geo-alt"></i> {{
                    trip.booking_request.booking_details.hotel_address }}</span>
                </div>
              </div>

              <div class="card-details-row">
                <div class="price-display">
                  <span class="price-label">Total Price</span>
                  <span class="price-value">
                    {{ trip.booking_request.booking_details.currency }} {{
                    trip.booking_request.booking_details.total_price | number }}
                  </span>
                </div>

                <div class="trip-info-summary">
                  <span class="info-date">
                    {{ formatDateToYYYYMM(trip.booking_request.booking_details.checkin) }} - {{
                    formatDateToYYYYMM(trip.booking_request.booking_details.checkout) }}
                  </span>
                  <span class="info-meta">
                    {{ trip.booking_request.booking_details.rooms[0].room_type }}
                  </span>
                </div>
              </div>

              <div class="card-actions">
                <!-- <button type="button" class="btn-premium btn-details" (click)="handleTripModal(hotelContent, trip)">
                    <i class="bi bi-info-circle"></i> Details
                  </button> -->
                <button type="button" class="btn-premium btn-action" (click)="handleTripModal(hotelContent, trip)"
                  [disabled]="trip.isLoading">
                  <span *ngIf="!trip.isLoading">Approve / Reject</span>
                  <mat-spinner diameter="18" *ngIf="trip.isLoading"></mat-spinner>
                </button>
              </div>

              <!-- Hover Policy Overlay -->
              <div class="policy-overlay" *ngIf="trip.booking_request.policy_violations.length">
                <div class="overlay-inner p-4">
                  <h5 class="mb-3">Policy Violation</h5>
                  <div class="overlay-title mb-2 small">
                    {{ trip.booking_request.policy_violations[0]?.policy_name }}
                  </div>
                  <ul class="overlay-reasons list-unstyled text-start mb-4">
                    <li *ngFor="let reason of trip.booking_request.policy_violations[0]?.violations" class="small mb-2">
                      <i class="bi bi-exclamation-triangle-fill me-2 text-warning"></i>{{ reason }}
                    </li>
                  </ul>
                  <button type="button" class="btn btn-action btn-md w-100 fw-bold"
                    (click)="handleTripModal(hotelContent, trip)" [disabled]="trip.isLoading">
                    View Details & Act
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="hotels.length === 0 && !loader">
          <div class="no-approval-stages">
            <p>No Pending Hotel Approvals</p>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>